import { useCallback, useState } from 'react';

import { Button } from '@/components/design-system/Button';
import { FilteredTableLayout } from '@/components/layout/FilteredTableLayout';
import { useDrills } from '@/modules/ISM/api/drills/hooks';
import { DrillsTable } from '@/modules/ISM/components/DrillsTable';
import { PlusCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const defaultCriteria = {
  OrderByText: 'DueDate',
  MaxRows: '10',
  ActiveVessels: 'true'
};

export const ISM = () => {
  const { data: drills, isLoading, refetch } = useDrills(defaultCriteria, 'hierarchy');
  const { t } = useTranslation();
  const [isFiltersCollapsed, setIsFiltersCollapsed] = useState(true);

  const handleToggleFiltersCollapse = useCallback(() => {
    setIsFiltersCollapsed((prev) => !prev);
  }, []);

  return (
    <FilteredTableLayout
      filters={<div>Filters placeholder</div>}
      isFiltersCollapsed={isFiltersCollapsed}
      onToggleFiltersCollapse={handleToggleFiltersCollapse}
      tableHeader={
        <>
          <Button variant="outline" size="md">
            <PlusCircleOutlined className="h-4 w-4" />
            {t('actions.new')}
          </Button>
          <Button variant="outline" onClick={() => refetch()} size="md">
            <ReloadOutlined className="h-4 w-4" />
            {t('actions.refresh')}
          </Button>
        </>
      }
      table={<DrillsTable isLoading={isLoading} drills={drills ?? []} />}
    />
  );
};
